var bodyClasses = document.body.classList;
var isMobile = {
  Android: function() {
      return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
      return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

window.Lemonade = window.Lemonade || {};

// API for utility functions
var Utilities = (function() {
  
  return {
  
    handleize: function(str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },

    getQueryParam: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    openModal: function(el){
      $.fancybox.open([{
        maxWidth: 600,
        width: 600,
        height: 600,
        autoSize: true,
        href: el
      }], {
        padding: 50
      });    
    },

    addProductToCart: function(data, successCallback, errorCallback){
      $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json',
        data: data,
        success: function(data, textStatus, jqXHR) {
          if (textStatus === 'success') {
            Utilities.updateCart(successCallback, true);
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          errorCallback 
            ? errorCallback(jqXHR.responseJSON.description)
            : alert(jqXHR.responseJSON.description);
        }
      });
    },

    addProductsToCart: function(productQueue){
      if (productQueue.length) {
        var data = productQueue.shift();
        $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json',
          data: data,
          success: function(data, textStatus, jqXHR) {
            Utilities.addProductsToCart(productQueue);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            errorCallback && errorCallback(jqXHR.responseJSON.description);
          }
        });
      } else {
        document.location.href = '/cart';
      }
    },

    updateCartQuantity: function(data, successCallback, errorCallback){
      $.ajax({
        url: '/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: data,
        success: function(cart) {
          Utilities.updateCart(cart, true);
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      }); 
    },

    updateCart: function(callback, openFlyout){
      $.getJSON('/cart.js', function(cart){
        Utilities.renderCartFlyout(cart, openFlyout);
        //callback && callback(cart);
      });
    },

    changeCart: function(cartItemsQueue){
      if (cartItemsQueue.length) {
        var data = cartItemsQueue.shift();
        $.ajax('cart/change.js', {
          data: data,
          dataType: 'json',
          success: function(cart){
            Utilities.changeCart(cartItemsQueue);
          }
        })
      } else {
        window.location.reload();
      }
    }, 

    renderCartFlyout: function(cart, openFlyout){      
      cart.item_count === 0 
        ? Lemonade.cache.$cartFlyout.addClass('empty') 
        : Lemonade.cache.$cartFlyout.removeClass('empty');

      $('.CartCount').text(cart.item_count);

      // show cart flyout
      var source = $("#cart-template").html(),
          template = Handlebars.compile(source),
          items = [],
          classes,
          option_label,
          imgSmall;

      $.each(cart.items, function(i,variant){
        imgLarge = variant.image ? variant.image.replace(/^(.+)(\..+)$/, '$1_large$2') : '';
        classes = variant.discounted_price ? '' : 'free-item';
        option_label = (variant.handle == 'gift-card') ? 'Amount' : 'Color';
        price_qty = variant.discounted_price * variant.quantity;

        items.push({
          id: variant.id,
          vendor: variant.vendor,
          title: variant.product_title,
          variant_title: variant.variant_title,
          url: variant.url,
          qty: variant.quantity,
          price: Shopify.formatMoney(variant.discounted_price).replace('.00',''),
          price_total: Shopify.formatMoney(price_qty).replace('.00',''),
          image: imgLarge,
          option1: variant.variant_options[0],
          option2: variant.variant_options[1],
          option3: variant.variant_options[2],
          optionLabel: option_label,
          classes: classes
        });
      });

      $('#Subtotal span').html( Shopify.formatMoney( cart.total_price ).replace('.00','') );
      Lemonade.cache.$cartFlyoutProducts.html( template({items:items}) );
      openFlyout && Utilities.openCartFlyout();
    },

    resizeCartFlyout: function(){
      Lemonade.headerCalculations();	
		  Lemonade.cache.$cartFlyout.css('top', parseFloat(Lemonade.cache.$header.css('top')) + Lemonade.cache.$header.outerHeight());
    },

    getUrlParameter: function(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

  }
  

})();


// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {
		
		// General
		$win: $(window),
		$body: $('html,body'),
		$backToTop: $('#BackToTop'),
		
		// Header & Nav
		$header: $('#AppHeader'),
		$appPromo: $('#AppPromo'),
    headerSpecs: null,
		
		// Cart
		$cartCount: $('.CartCount'),
		$cartFlyout: $('#CartFlyout'),
		$cartFlyoutProducts: $('#CartFlyoutProducts'),
		$cartFlyoutSubtotal: $('#CartFlyoutSubtotal'),
		$cartQtyControl: $('.CartQty span'),
	};
	
};

// Kick off functions
Lemonade.init = function(){
	Lemonade.cacheSelectors();
	Lemonade.lazyLoad();
	Lemonade.globalHeader();
	Lemonade.billboards();
	Lemonade.accordion();
	if(liquidVars.enableNewsletterPopup == 'true'){
    Lemonade.popup();
  }
	Lemonade.slick();
	Lemonade.autoResponsiveElements();
	Lemonade.cache.$win.load(function(){
		Lemonade.fitVids();
	});
	
	Lemonade.popupModules();
	//Lemonade.productHover();
  Lemonade.mailchimp();

	if(bodyClasses.contains('template-product')){
    Lemonade.productMedia();
    if(liquidVars.enableZoom == 'true'){
      Lemonade.productZoom();
    }
  }
  
  Lemonade.customProductSelects();
	Lemonade.customSelects();
	Lemonade.productQuantity();
	Lemonade.initCartFlyout();
	Lemonade.cartPage();
	Lemonade.gdpr();
	Lemonade.labels();
	Lemonade.videos();
  Lemonade.retailersNav();
  Lemonade.swatchImageUpdate();
  
	if(bodyClasses.contains('template-collection')){
		Lemonade.collectionAjaxLoad();
		Lemonade.backToTop();
	}
	if(bodyClasses.contains('template-blog')){
		Lemonade.blogPage();
	}  
};

// Lazy Load library dependancy http://jquery.eisbehr.de/lazy
// Dynamically load images
Lemonade.lazyLoad = function(){
	$('.Lazy').Lazy({
		effect: 'fadeIn',
		visibilityOnly: true,
		onError: function(element){
			console.log('error loading ' + element.data('src'));
		},
		afterLoad: function(element) {
			if(bodyClasses.contains('template-product')){
				Lemonade.productZoom();
			}
		}
	});
};

// Return window scrollTop
Lemonade.windowScrollTop = function(){
	return $(window).scrollTop();
};

// Body no scroll
Lemonade.scrollYes = function(){
	Lemonade.cache.$body.removeClass('NoScroll');
};

// Body yes scroll
Lemonade.scrollNo = function(){
	Lemonade.cache.$body.addClass('NoScroll');
};

// Return a bunch of header specs
Lemonade.headerCalculations = function(){
	  
	var total_offset = 0;
	if (Lemonade.cache.$appPromo.length > 0) {
		total_offset = Lemonade.cache.$appPromo.outerHeight() - Lemonade.cache.$win.scrollTop();
		if (total_offset < 0) {
			total_offset = 0;
		}
	}

  	Lemonade.cache.headerSpecs = {
	  	header_height: Lemonade.cache.$header.height(),
	  	bar_height: Lemonade.cache.$appPromo.outerHeight(),
	  	header_plus_bar: Lemonade.cache.$header.height() + Lemonade.cache.$appPromo.outerHeight(),
	  	total_offset: total_offset
  	};
  
  return Lemonade.cache.headerSpecs;
	
};

// Global Header + Navigation
Lemonade.globalHeader = function(){
	
	// init settings and selectors
	var $megaMenu = $('.MegaMenu'),
      $navMobile = $('#AppNavMobile'),
      $btnMobileMenu = $('#BtnMobileMenu'),
      megaTimer,
	    winPos,
	    state,
      winState;
	
	// Check state of window width (wide vs narrow screen)
	var winState = function() {
		winWidth = Lemonade.cache.$win.width();
		if(winWidth > 1023){
			if (state != 'max') {
				state = 'max';
				changedstate(state);
			};
		} else if (winWidth > 767 && winWidth <= 1023){
			if (state != 'desktop') {
				state = 'desktop';
				changedstate(state);
			};
		} else {
			if (state != 'mobile') {
				state = 'mobile';
				changedstate(state);
			};
		}
	}

  // If/When window crosses the wide/narrow threshold you can do some stuff here
	function changedstate(mystate){
		if(mystate == 'max'){
			Lemonade.cache.$body
				.removeClass('NarrowScreen WideScreen')
				.addClass('MaxScreen');
			// Close mobile menu if going to wide screen
			closeMobileMenu();
		} else if(mystate == 'desktop'){
			// Do wide screen stuff here
			Lemonade.cache.$body
			  .removeClass('NarrowScreen MaxScreen')
				.addClass('WideScreen');
	  } else {
		  // Do narrow screen stuff here
		  Lemonade.cache.$body
		    .removeClass('WideScreen MaxScreen')
			  .addClass('NarrowScreen');
	  }
	}
	
	// Loops through a standard Shopify menu/submenu structure and pulls the sub menus out of their parent-child DOM relationship
	function buildMegaMenus(){
		$('.HasDropdown').each(function(i,el){
			var $me = $(el),
			    $meSub = $me.next('.SiteNavDropdown');
      Lemonade.cache.$header.append($meSub);
		});
	}
  
	// Header Utilities (toggle items visible/hidden)
	function headerUtilities(){
		$('.UtilTrigger').on('click', function(e){
			e.preventDefault();			
      var $me = $(this);
      $me.siblings().removeClass('Active').attr('aria-expanded', 'false');
      $('.UtilItem').removeClass('Show').attr('aria-hidden', 'true');
      if($me.hasClass('Active')){
        $me.removeClass('Active').attr('aria-expanded', 'false');
        meItem = $me.data('utility');
        $('#'+meItem).removeClass('Show').attr('aria-hidden', 'true');
      } else {
        $me.addClass('Active').attr('aria-expanded', 'true');
        meItem = $me.data('utility');
        $('#'+meItem).addClass('Show').attr('aria-hidden', 'false');
      }	
		});
	}
	
	// Header transition on scroll
	var transitionPoint = function(){
		
		// get the current header specs/dimensions
		Lemonade.headerCalculations();
		
		Lemonade.cache.$header.css('top', Lemonade.cache.headerSpecs.total_offset);
		
		// get window scroll position
		winPos = Lemonade.cache.$win.scrollTop();

		if(winPos > 0){
			if(!Lemonade.cache.$header.hasClass('ScrolledPast')){
				Lemonade.cache.$header.addClass('ScrolledPast');
				
			}
		} else {
			if(Lemonade.cache.$header.hasClass('ScrolledPast')){
				Lemonade.cache.$header.removeClass('ScrolledPast');
			}
		}
	};

	function isMobileMenuOpened() {
		return $navMobile.hasClass('ShowMenu');
	}

	function openMobileMenu(){
		if (isMobileMenuOpened()) return;
		
		$btnMobileMenu.addClass('Open');
		$navMobile.css('top', parseInt(Lemonade.cache.$header.css('top')) + Lemonade.cache.$header.outerHeight());
		$navMobile.addClass('ShowMenu');
		Lemonade.scrollNo();
		Lemonade.cache.$header.addClass('Open');
	}

	function closeMobileMenu(){
		if (!isMobileMenuOpened()) return;

		$btnMobileMenu.removeClass('Open');
		$navMobile.removeClass('ShowMenu');
		Lemonade.scrollYes();
		Lemonade.cache.$header.removeClass('Open');
	}

	function toggleMobileMenu(){
		closeCartFlyout();

		if(isMobileMenuOpened()){
			closeMobileMenu();
		} else {
			closeCartFlyout();
			openMobileMenu();
		}
	}
	
	function isCartFlyoutOpened() {
		return Lemonade.cache.$cartFlyout.hasClass('Show');
	}

    function openCartFlyout(){
		if (isCartFlyoutOpened()) return;

		Utilities.resizeCartFlyout();
		$btnMobileMenu.addClass('Open');
		Lemonade.cache.$cartFlyout.addClass('Show');
		if (Lemonade.cache.$win.width() < 1024) {
			Lemonade.cache.$header.addClass('Open');
		}
		Lemonade.scrollNo();
	}
	Utilities.openCartFlyout = openCartFlyout;

    function closeCartFlyout(){
		if (!isCartFlyoutOpened()) return;
		
		$btnMobileMenu.removeClass('Open');
		Lemonade.cache.$cartFlyout.removeClass('Show');
		Lemonade.cache.$header.removeClass('Open');
	  	Lemonade.scrollYes();
	}
	
	function toggleCartFlyout(){
		closeMobileMenu();

		if (isCartFlyoutOpened()) {
			closeCartFlyout();
		} else {
			openCartFlyout();
		}
	};

  $('#AppNavUL > li > a').on('mouseenter mouseleave click', function(e){
    var $me = $(this),
        meMenu;
    
      if(e.type == 'click'){
        if($me.hasClass('Active')){
          closeMega();
        } else if($me.hasClass('HasDropdown')) {
          clearTimeout(megaTimer);
          meMenu = $me.attr('data-mega-menu');
          $me.addClass('Active');
		  $('#'+meMenu).show().siblings('.MegaMenu').hide();
		  Lemonade.cache.$header.addClass('ShowMega');
        }
      } else if(e.type == 'mouseenter'){
        if($me.hasClass('HasDropdown')){
          clearTimeout(megaTimer);
          meMenu = $me.attr('data-mega-menu');
          $me.addClass('Active');
		  $('#'+meMenu).show().siblings('.MegaMenu').hide();
		  Lemonade.cache.$header.addClass('ShowMega');
        } else {
          closeMega();
        }
      } else if(e.type == 'mouseleave'){
        megaTimer = setTimeout(function(){
          closeMega();
        }, 300);
      }
  });

  function closeMega(){
	$('.HasDropdown').removeClass('Active');
	Lemonade.cache.$header.removeClass('ShowMega');
    $megaMenu.hide();
  }

  $megaMenu.on('mouseenter mouseleave', function(e){
    if(e.type == 'mouseenter'){
      clearTimeout(megaTimer);
    } else if(e.type == 'mouseleave'){
      closeMega();
    }
    
  });

	
	// Toggle the mobile menu
	$btnMobileMenu.on('click', function() {
		if (isCartFlyoutOpened()) {
			closeCartFlyout();
			return;
		}
		toggleMobileMenu();
	});

	$('.CartTrigger').on('click keyup', function(e){
		e.stopPropagation();
		e.preventDefault();
		if(e.type == "click" || e.which == 13 ){
			toggleCartFlyout();
		}
	});

	$('#CartFlyout .icon-close').add('.main-content').add('#AppHeader').add('#AppPromo').on('click keyup', function(e){
		e.stopPropagation();
		if(e.type == "click" || e.which == 13 ){
			closeCartFlyout();
		}
	});
	
	buildMegaMenus();
	
	transitionPoint();
	
	winState();
	
	headerUtilities();
	
	Lemonade.cache.$win.on({
		scroll: function(){
			transitionPoint();	
		},
		resize: function(){
			winState();
		}
	});	
		
};

// Billboards and Heros
Lemonade.billboards = function(){
	var $billboardBG = $('.fit, .BillboardBGVideo');
		
	function billboard(el){
		Lemonade.headerCalculations();
		var $me = el,
		    winHeight = Lemonade.cache.$win.height();
		    billboardHeight = winHeight - Lemonade.cache.headerSpecs.total_offset;
    $me.height(billboardHeight);
	}
	
	billboard($billboardBG);
	
	Lemonade.cache.$win.resize(function(){
		billboard($billboardBG);
	});
	
};

// Content accordions
Lemonade.accordion = function(){
	
  var $accTrigger = $('.AccTrigger'),
      $acc = $('.AccContent');
  
  // accordian content    
  $accTrigger.click(function(e){
	  e.preventDefault();
    var $me = $(this),
        $content = $me.next('.AccContent');
        
    $acc.slideUp();
    if($me.hasClass('Open')){
      $me.removeClass('Open');
      return false;
    }
    $accTrigger.removeClass('Open');
    $me.addClass('Open');
    $content.slideToggle();
  });	
	
};

// Popup Newsletter
Lemonade.popup = function(){

  var cookieExpire = parseInt(liquidVars.popupExpire);

	function newsletterPopup(){	
    $.fancybox.open([{
      width: 580,
      height: 'auto',
      autoSize: false,
	    href: '#NewsletterPopup'
    }], {
	    padding: 0
    });	  
	}
	
  if (typeof $.cookie('newsletter-modal') === 'undefined') {
    $.cookie('newsletter-modal', '1', { expires: cookieExpire, path: '/' });
    setTimeout(function(){
			newsletterPopup(); 
		}, 3000);
  }	

  $('.popupClose').click(function(){
    $.fancybox.close();
  })
  	
};

// Library dependancy https://github.com/kenwheeler/slick/
// Slick init
Lemonade.slick = function(){
	
  var $slick = $('.Slick');
  
  $slick.on('init', Lemonade.slickAlignArrows);
	
	$slick.slick({
		lazyLoad: 'progressive'
  });

};

// Slick carousel vertically align prev/next arrows to carousel item image
Lemonade.slickAlignArrows = function(){
	
	setTimeout(function(){
    
		$('.SliderWrap').each(function(i, el){
			var $me = $(el);
			if($me.hasClass('carousel')){
				var imgHeight = $me.find('.slick-slide').first().find('img').first().height() / 2;
			  $me.find('.slick-arrow').css({'top': imgHeight});
			} else {
				$('.SlideArrow').addClass('init');
			}
			
		});
	}, 500);
	
};

Lemonade.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
      $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Video embed sizing http://fitvidsjs.com/
Lemonade.fitVids = function(){
	Lemonade.cache.$body.find('.video-wrapper').fitVids();
};

// Product switch image handler
Lemonade.selectProductImage = function($thumb) {
  if ($thumb.length === 0) return;
  $('.ProductThumb').removeClass('Active Active-1 Active-2 Active-3 Active-4');
  $thumb.addClass('Active Active-' + (Math.floor(Math.random() * 4) + 1));
  $('.ProductSlick').slick('slickGoTo', $('.ProductThumb:not(.hidden)').index($thumb));
}

// PDP thumb switch
Lemonade.productMedia = function() {

	var instance = $('.ProductVideo').data('vide');

	$('.ProductThumb').click(function(e){
    Lemonade.selectProductImage($(this));
	});

	$('.ProductVideo').click(function(){
		var $me = $(this).next('.PlayBtn');
		if(instance){
			vid = instance.getVideoObject();
			if (vid.paused) {
				$me
					.find('.Play')
					.hide()
					.end()
					.find('.Pause')
					.show();
				vid.play();
			} else {
				$me
					.find('.Pause')
					.hide()
					.end()
					.find('.Play')
					.show();
				vid.pause();
			}
		}      
	});  
};

// Back to top
Lemonade.backToTop = function(){
	
	if(Lemonade.cache.$backToTop.length > 0){
		
		function showBackToTop(){
			var gridPos = $('.GridWrapper').offset().top;
			if(Lemonade.windowScrollTop() > gridPos){
				Lemonade.cache.$backToTop.fadeIn();
			} else {
				Lemonade.cache.$backToTop.fadeOut();
			}
		}
			
		Lemonade.cache.$backToTop.click(function(){
			Lemonade.cache.$body.animate({'scrollTop': 0});
		});
		
		Lemonade.cache.$win.scroll(function(){
			showBackToTop();	
		});
	}
	
};

// Fancybox popups
Lemonade.popupModules = function(){
	
	$('.PopupTrigger').click(function(e){
		
		var $me = $(this),
				meDataPopup = $me.data('popup'),
				$mePopup = '#'+meDataPopup;
		
		$.fancybox.open([{
			width: 600,
			height: 600,
			autoSize: true,
			href: $mePopup
		}], {
			padding: 30
		});
	});
		
};

// Product grid hover photo
Lemonade.productHover = function(){
	
	var speed = 200;
	
	$('.ItemImage').on({
		mouseenter: function(){
			var $me = $(this),
			    $meHoverImg = $me.find('.HoverImg');
			
			if($meHoverImg.length > 0){
				$meHoverImg.stop().fadeIn(speed);
				$me.find('img').first().stop().fadeOut(speed);
			}
		},
		mouseleave: function(){
			var $me = $(this),
			    $meHoverImg = $me.find('.HoverImg');
			
			if($meHoverImg.length > 0){
				$me.find('.HoverImg').stop().fadeOut(speed);
				$me.find('img').first().stop().fadeIn(speed);
			}
		}
	});
	
};

// Mailchimp Ajax submit
Lemonade.mailchimp = function(){
	
	var statusMessage;
		
	function mailchimpSubmit(formSubmit){
		
		var $meSubmit = $(formSubmit),
		    $meForm = $meSubmit.closest('form');
		
		$.ajax({
	    type: $meForm.attr('method'),
	    url: $meForm.attr('action'),
	    data: $meForm.serialize(),
	    cache       : false,
	    dataType    : 'json',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if(data.result != "success") {
          if(liquidVars.signupFail){
		        statusMessage = liquidVars.signupFail;
          } else {
		        statusMessage = 'Sorry try again later.';
          }
        } else {
	        if(liquidVars.signupSuccess){
            statusMessage = liquidVars.signupSuccess;
          } else {
		        statusMessage = 'Thanks';
          }
        }
				$meForm.next('.SubscribeStatus').html(statusMessage).fadeIn(function(){
					setTimeout(function(){
						$meForm.next('.SubscribeStatus').fadeOut(function(){
							$(this).html('');
              $meForm.find('input[type="email"]').val('');
              $.fancybox.close();
						});							
					}, 3000);
				});
      }
	  });
	}
	
	$('.NewsletterContainer').on('click', 'input[type="submit"]', function(e){
		e.preventDefault();
		mailchimpSubmit($(this));
	});
	
	
};

// Product Zoom
Lemonade.productZoom = function(){  
  var $takeover = $('#Takeover');

  $('.ZoomTrigger').click(function(){
    var src = $(this).next('img').attr('src'),
        largerSrc = src.replace('1024x1024', '2048x2048');
    $takeover.find('img').attr('src', largerSrc);
    setTimeout(function(){
      $takeover.fadeIn(function(){
        Lemonade.scrollNo();
      });
    }, 200);
  });
  
  $takeover.click(function(){
    $takeover.fadeOut(function(){
      $takeover.find('img').attr('src', '');	
      Lemonade.scrollYes();
    });
  });	
}; 

// Product custom selects
Lemonade.customProductSelects = function(){
  var $selectorWrap = $('.selector-wrapper');
	
	// Loop through all variant options and construct custom UI
	$selectorWrap.each(function(i,el){
		var $me = $(el),
				$meSelect = $me.find('.single-option-selector'),
				$meLabel = $me.find('label'),
				$meOptions = $me.find('option'),
        $meUlLeather = $('<div class="material-row"><span class="label">Leather</span><ul class="OptionSelect"></ul></div>'),
        $meUlCanvas = $('<div class="material-row"><span class="label">Canvas</span><ul class="OptionSelect"></ul></div>'),
        $meUlNylon = $('<div class="material-row"><span class="label">Nylon</span><ul class="OptionSelect"></ul></div>'),
        $meUl = $('<div class="material-row"><span class="label"></span><ul class="OptionSelect"></ul></div>'),
        optionField = $meSelect.data('option');

		// build options in option select dropdown with data-attributes derived from real select
		$meOptions.each(function(i, el){
			var $el = $(el),
          meText = $el.text(),
          meTextStripped = meText.replace(" USD", ""),
					meVal = $el.val().replace(/["]/g, "&quot;"),
					meHandle = meText.replace(/["]/g, "&quot;"),
          meHandle = meHandle.toLowerCase(),
          isSelected = Boolean(Lemonade.selectedVariant && Lemonade.selectedVariant[optionField] === meText);

      if (isSelected) {
        $('.color-label').find('span').text(meTextStripped);
      }

      if(meVal.includes('Canvas')){
        $meUlCanvas.find('ul').append('<li class="swatch-li ' + meHandle.replace(new RegExp(' ', 'g'), '-') + (isSelected ? ' Active' : '') + '" data-val="' + meVal + '">' + meText + '</li>');
      } else if(meVal.includes('Leather')){
        $meUlLeather.find('ul').append('<li class="swatch-li ' + meHandle.replace(new RegExp(' ', 'g'), '-') + (isSelected ? ' Active' : '') + '" data-val="' + meVal + '">' + meText + '</li>');
      } else if (meVal.includes('Nylon')) {
        $meUlNylon.find('ul').append('<li class="swatch-li ' + meHandle.replace(new RegExp(' ', 'g'), '-') + (isSelected ? ' Active' : '') + '" data-val="' + meVal + '">' + meText + '</li>');
      } else {
        $meUl.find('ul').append('<li class="text-li' + (isSelected ? ' Active' : '') + '" data-val="' + meVal + '">' + meTextStripped + '</li>');
      }
    });		

		// Hide default select field + label
		$meLabel.add($meSelect).hide();

    // Add new selections to DOM
    if ($meUlNylon.find('li').length > 0) {
      $me.prepend($meUlNylon);
    }
    if ($meUlCanvas.find('li').length > 0) {
      $me.prepend($meUlCanvas);
    }
    if ($meUlLeather.find('li').length > 0) {
      $me.prepend($meUlLeather);
    }
    if ($meUl.find('li').length > 0) {
      $me.prepend($meUl);
    }    
	});
	
};

Lemonade.customSelects = function(){
  var $selectorWrap = $('.selector-wrapper, .fake-select'),
      $addForm = $('#AddToCartForm');
	
  $addForm.on('click', '.selector-wrapper li', function(e){
		e.stopPropagation();
		var $me = $(this),
        meVal = $me.data('val'),
        meValStripped = $me.text().replace(" USD", "");
        
    $('.color-label').find('span').text(meValStripped);

    $addForm.find('.selector-wrapper li').removeClass('Active');
  
		if(!$me.hasClass('Active')){			
			$me
				.addClass('Active')
				.siblings('li')
				.removeClass('Active')
				.end()
				.closest('.selector-wrapper')
				.find('.single-option-selector')
				.val(meVal)
				.change();
		}
		
  });	

  $('#AddToCartForm').on('mouseenter', '.selector-wrapper .swatch-li', function(e){
    var $me = $(this);
    if($me.hasClass('tilt')){
      $me.removeClass('tilt');
    } else {
      $me.addClass('tilt');
    }
  });

  $('#AddToCartForm').on('mouseleave', '.selector-wrapper .swatch-li', function(e){
    var $me = $(this);
    $me.removeClass('tilt');
  });  

	$selectorWrap.on('click', '.OptionBox', function(e){
		e.stopPropagation();
    var $me = $(this);
		if($me.hasClass('Active')){
			$me
				.removeClass('Active')
				.next('.OptionSelect')
				.hide();
		} else {
			$selectorWrap.find('.OptionBox').removeClass('Active').next('.OptionSelect').hide();
      $me
        .removeClass('tilt')
				.addClass('Active')
				.next('.OptionSelect')
				.show();
		}
	});
};

// Custom product quantity
Lemonade.productQuantity = function(){
	
  $(".Qty").find('span').on("click", function() {
	
	  var $button = $(this);
	  var oldValue = $('.Quantity').val();
		
	  if ($button.hasClass('up')) {
		  var newVal = parseFloat(oldValue) + 1;
		} else {
	   // Don't allow decrementing below one
	    if (oldValue > 0) {
	      var newVal = parseFloat(oldValue) - 1;
	    } else {
	      newVal = 0;
	    }
	  }
	
	  $('.Quantity').val(newVal);
	
	});
	
};

// Product Page
Lemonade.changeVariant = function(options){
  
  function setAffirmAppPricing(price){
    affirm.ui.ready(
      function() {
        $('.affirm-as-low-as').attr('data-amount',price);
          affirm.ui.refresh();
      }
    );
  }

  function setPreorderState(variant){
    if (variant.preorder) {
      $('#AddToCartForm').append('<input type="hidden" id="prop-preorder" name="properties[Preorder]" value="'+variant.preorder+'" />');
      $('#PreorderMessage').text(variant.preorder);
    } else {
      $('#prop-preorder').remove();
      $('#PreorderMessage').text('');
    }
  }

  var moneyFormat = options.money_format,
      variant = options.variant,
      translations = options.translations,
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
			$quantityElements = $('.ProductQty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    //HC - Remove Affirm installments - 05 August 22 
    //setAffirmAppPricing(variant.price);
    setPreorderState(variant);

    Lemonade.updateProductImagesSlider(variant);
    
    // Select a valid variant if available

    if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			$addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.show();  
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.sold_out);
			$quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
		$quantityElements.hide();
  }

};

Lemonade.safeInitProductImagesSlider = function() {
  var $slider = $('.ProductSlick');
  
  if ($slider.length === 0 || $slider.hasClass('slick-initialized')) return;

  $slider.on('init', Lemonade.slickAlignArrows);
  $slider.slick($slider.data('slick'));
}

// Update PDP thumbnails
Lemonade.updateProductImagesSlider = function(variant) {
	var $slider = $('.ProductSlick'),
    ind,color;

	$.each(productJSON.options, function(i,el){
		if(el == 'Color'){
      ind = i + 1;
      return false;
		}
  });
  
  color = variant['option' + ind];
  
	if (color){

    Lemonade.safeInitProductImagesSlider();

    $('.ProductThumb')
      .hide()
      .addClass('hidden')
      .filter('[data-alt="' + color + '"]')
      .removeClass('hidden')
      .show();
    
    $slider.slick('slickUnfilter');
    $slider.slick('slickFilter', '[data-alt="' + color + '"]');
    
    Lemonade.selectProductImage($('.ProductThumb:not(.hidden)').first());
  } else {
    if ($slider.length === 0 || $slider.hasClass('slick-initialized')) return;
    $slider.on('init', Lemonade.slickAlignArrows);
    $slider.slick();
  }

};

// Add to cart button states
Lemonade.addToCartflip = function($addToCartBtn){

  // Get label of add to cart button
	var addToCartText = liquidVars.transAddToCart;
	
  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text(liquidVars.transViewCart)
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped')
    .after('<div class="ContinueShopping"> <a class="btn--secondary" href="/collections/all">'+liquidVars.transContinueShopping+'</a></div>');

  $('.ContinueShopping a').bind('click', Lemonade.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .ContinueShopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

Lemonade.initCartFlyout = function(){

  function getCartJSON(callback, show_flyout){
    $.getJSON('/cart.js', function(cart) {
      if (typeof callback !== undefined) {
				Lemonade.cache.$cartCount.text(cart.item_count);		
        callback(cart, show_flyout);
      }
    })
  }

  function addToCart(e){
    e.preventDefault();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
				$addToCartBtnText = $(this).find('span');
		$('.note.errors').remove();
    if($addToCartForm.length) {
			$addToCartBtn
				.attr('data-add-to-cart', $addToCartBtnText.text())
				.prop('disabled', true)
				.addClass('disabled btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
					$addToCartBtn
						.removeClass('btn--loading')
						.prop('disabled', false)
						.removeClass('disabled btn--loading');
					getCartJSON(Utilities.renderCartFlyout, true);
				},
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text(liquidVars.sold_out);
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.closest('.btn-wrap').append('<p class="note errors">' + response + '</p>');
        }
      });
    }
  };

	function updateQuantity(el, isAjax){
		var $button = $(el),
			$qty = $button.parent().find('.Quantity'),
			oldQty = $qty.val(),
			newQty = parseFloat(oldQty),
			variant_id = $qty.data('variant');
		
		if ($button.hasClass('up')) {
			newQty = parseFloat(oldQty) + 1;
		} else {
			if (oldQty > 0) {
				newQty = parseFloat(oldQty) - 1;
			} else {
				newQty = 0;
			}
		}
		
		if (isAjax) {
			Utilities.updateCartQuantity({id: variant_id, quantity: newQty}, function(){
				$qty.attr('value', newQty);
			});
			return
		}

		$qty.attr('value', newQty);
	}

  var $addToCartBtn = $('form[action^="/cart/add"] :submit');
  $addToCartBtn.on('click', addToCart);

  Lemonade.cache.$win.on('resize load', function(e){
    Utilities.resizeCartFlyout();
    if(e.type == 'load'){
      setTimeout(function(){
        Utilities.resizeCartFlyout();
      }, 1500);
    }
  });

  	Lemonade.cache.$cartFlyout
		.on('click keyup', '.FlyoutQty span', function(e){
			if(e.type == "click" || e.which == 13 ){
				$('.FlyoutQty').addClass('processing');
				updateQuantity(this, true);
			}
		})
		.on('click', '.Remove', function(e){
			if(e.type == "click" || e.which == 13 ){
				Utilities.updateCartQuantity({id: parseFloat($(this).attr('data-variant-id')), quantity: 0});
			}
		});
	
	Lemonade.cache.$cartQtyControl
		.on('click keyup', function(e){
			if(e.type == "click" || e.which == 13 ){
				updateQuantity(this);
			}
		});
  
	getCartJSON(Utilities.renderCartFlyout, false);  
	Utilities.resizeCartFlyout();
};

Lemonade.cartPage = function(){
	$('.NoteAdd').click(function(){
		//$(this).hide();
		$('.CartNote').toggle();
	});
};

Lemonade.gdpr = function(){

	var $gdpr = $('#Gdpr');

  if (typeof $.cookie('gdpr-modal') === 'undefined') {
		setTimeout(function(){
			$gdpr.addClass('show'); 
		}, 1500);

		$('#GdprAgree').click(function(){
			var $me = $(this);
			if($me.is(':checked')){
				setTimeout(function(){
					$gdpr.removeClass('show');
				}, 400);
				$.cookie('gdpr-modal', '1', { expires: 90, path: '/' });
			}
		});
  }		
};

Lemonade.swatchImageUpdate = function(){
  $('.item-swatches').on('mouseenter mouseleave', '.isw', function(e){
    var $me = $(this),
        $meProduct = $me.closest('.product-item'),
        meHandle = $me.attr('data-product-handle'),
        meIndex = $me.attr('data-swatch-index') - 1;

    if(e.type == 'mouseenter'){
      $.ajax({
        url: '/products/'+meHandle+'?view=json',
        dataType: 'html',
        async: true,
        success: function(meta){
          var pics = JSON.parse(meta),
              mePic = pics.images[meIndex];

          $meProduct.find('.ItemImage').append('<img class="newPic" src="'+mePic+'" alt="" />');
        }
      });
    } else {
      $meProduct.find('.newPic').remove();
    }
  });
};

Lemonade.collectionAjaxLoad = function(){

	var $loadMore = $("#LoadMore"),
			loadMoreText = $loadMore.attr('data-button-text'),
			pageNumber = 1;
			
	// Load more products into the page via AJAX API
	function loadMoreProducts(me, pageNumber, path) {
		var wrap = me.closest('.LoadMoreWrapper').closest('.collection-products').find('.AjaxPager'),
				maxpage = me.data('maxpage'),
				theQuery,
				url,
				json_path = 'json';

		if (!path) {
			path = location.pathname;
			theQuery = location.search;

			if (theQuery){
				url = path + theQuery + '&page=' + pageNumber;
			} else {
				url = path + '?page=' + pageNumber;
			}
		}

		$.ajax({
			type: 'GET',
			dataType: 'html',
			url: url,
			data: theQuery,
			success: function(data) {
				var $data = $(data),
						$new_posts = $data.find(".AjaxPager").html(),
            wrapIndex;
	
				if ($data.length) {
					wrapIndex = pageNumber - 2;
					$(".AjaxPager").append($new_posts);
					Lemonade.lazyLoad();
					me.attr("disabled", false);
					if (maxpage === pageNumber) {
						me.hide();
						$('.LoadMoreWrapper').hide();
					} else {
						me.attr("disabled", false);
					}
				}
			},
			error: function(data) {
				return wrap.append('<div>Something Went Wrong</div>');
			}
		});
	}

	// Trigger AJAX Load more on collection page
	$loadMore.click(function(e) {
		pageNumber++;
		loadMoreProducts($(this), pageNumber);
	});

};

Lemonade.labels = function(){

  var $fieldInputs = $('.field-wrap').find('input').add('select').add('textarea');

  $fieldInputs.on('blur', function(){
    if($(this).val() == '' || $(this).val() == null){
      $(this).closest('.field-wrap').removeClass('float');
    }
  });

  $fieldInputs.on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this);
      if($me.is(':focus')){
        $me.closest('.field-wrap').addClass('float');
      }
    }
  });

  $fieldInputs.bind("change keyup",function(){
    $(this).closest('.field-wrap').addClass('float');
  });  

  function inputCheck(){
    $fieldInputs.each(function(i,el){
      var $me = $(el);
      if($me.is(':focus') || $me.is(':-webkit-autofill') || $me.val() != ''){
        $me.closest('.field-wrap').addClass('float');
      }
    });
  }

  Lemonade.cache.$win.load(function(){
    inputCheck();
  });
  
};

Lemonade.blogPage = function(){

  var $blogWrapper = $('.BlogWrapper'),
      $filterTrigger = $('.FilterTrigger'),
      totalWidth = 0;

  $filterTrigger.click(function(){
    var $me = $(this),
        meVal = $me.attr('data-filter');

    if(!$me.hasClass('Active')){
      $me.addClass('Active').siblings('li').removeClass('Active');
      $blogWrapper.find('.'+meVal);

      if(meVal != 'show-all'){
        $blogWrapper.find('.article-item').hide();
        $blogWrapper.find('.'+meVal).show();
      } else {
        $blogWrapper.find('.article-item').show();
        $('#ShowAll').addClass('active');
      }

    }
  });

  function horzMenu(){
    $filterTrigger.each(function(i,el){
      var $me = $(el),
          me_width = $me.width();
      totalWidth = totalWidth + me_width;
    });
    $('#FilterList').width(totalWidth);
  }


  Lemonade.cache.$win.on({
    load: function(){
      if(Lemonade.cache.$body.hasClass('NarrowScreen')){
        horzMenu();
      }
    },
    resize: function(){
      //horzMenu();
    }
  })


  
}

Lemonade.videos = function(){
  $('.video-wrap').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this),
          meVid = $me.find('video').get(0),
          meImg = $me.find('img'),
          meControls = $me.find('.PlayBtn');
      if(meVid.paused){
        meVid.play();
        meImg.hide();
        meControls.hide();
      } else {
        meVid.pause();
        meControls.show();
      }
    }
  });
}

Lemonade.retailersNav = function() {
	var $partials = $('.RetailersPartial');
	var $retailersNavItem = $('.retailers-nav a');
	var activeClass = 'active';
	var filteredClass = 'filtered';

	$retailersNavItem.on('click', function(e) {
		e.preventDefault();

		var $self = $(this);
		var $retailers = $self.closest('.retailers');
		var category = $self.data('category');
				
		$retailersNavItem.removeClass(activeClass);
		$self.addClass(activeClass);
		
		if (!category) {
			$retailers.removeClass(filteredClass);
			$partials.show();
			return;
		}
		
		$retailers.addClass(filteredClass);
		$partials.hide();
		$partials.filter('[data-category="' + category + '"]').show();
	});
}

// Initialize Lemonade JS on docready
$(Lemonade.init);